import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import { DelayCategory } from "../models/DelayCategory";

export const getDelayCategories = async (assetId?: number | null) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [];

	if (assetId) parameters.push({ name: "DelayAreaAssetId", value: assetId });
	if (assetId && assetId !== 0)
		parameters.push({ name: "IncludeAncestor", value: true });

	const resp = await apiService.callV2(
		"[DEL].[GetDelayCategories]",
		parameters,
	);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as DelayCategory[];
	} else {
		throw new Error(resp.message || "Error fetching arbors");
	}
};
